import React, { useContext, useEffect, useMemo, useState } from 'react'
import { View, Text, FlatList } from 'react-native'
import { FreshWaterContext } from '../../context/FreshWater/FreshWaterContext'
import { OptionsItem } from '../OptionsItem'
import { InitialInputVoiceSearch } from '../VoiceSearch/InitialInput/InitialInput'
import { corporateColor } from '../../theme/colors'
import { AuthContext } from '../../context/Auth/AuthContext'
import { SeaWaterContext } from '../../context/SeaWater/SeaWaterContext'
import { useTranslation } from 'react-i18next'
import { AreaSelected } from '../../context/Auth/AuthReducer'
import { Option } from '../../context/FreshWater/types'
import { DataMapType } from '../../types'
interface Props {
  onChange: (value: number) => void
  initialValue?: number
}
export const PiscicultureCenter = ({ onChange, initialValue }: Props) => {
  const {
    user: { areaSelected },
  } = useContext(AuthContext)

  const { piscicultures } = useContext(FreshWaterContext)
  const { centers } = useContext(SeaWaterContext)

  const dataMap: DataMapType = useMemo(
    () => ({
      sweetWater: piscicultures,
      seaWater: centers,
    }),
    [],
  )
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState<number | null>(() => initialValue ?? null)
  const [search, setSearch] = useState('')
  const [filteredData, setfilteredData] = useState<{ name: string; id: number }[]>([])

  const handleOptionPress = (id: number) => {
    setSelectedOption(id === selectedOption ? null : id)
  }
  const getSearchValue = (value: string) => setSearch(value)

  useEffect(() => {
    if (selectedOption !== null) {
      onChange(selectedOption)
    }
  }, [selectedOption])

  useEffect(() => {
    setfilteredData(
      dataMap[areaSelected!]!.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase()),
      ),
    )
  }, [search])

  return (
    <View>
      <Text style={{ textAlign: 'center', fontWeight: 'bold', color: corporateColor }}>
        {areaSelected === 'sweetWater'
          ? t('Selecciona una piscicultura')
          : t('Selecciona un centro')}
      </Text>
      <InitialInputVoiceSearch
        placeholder={areaSelected === 'sweetWater' ? t('BUSCAR PISCICULTURA') : t('BUSCAR CENTRO')}
        getSearchValue={getSearchValue}
        hasInput
      />
      <FlatList
        style={{ marginTop: 10 }}
        data={filteredData}
        renderItem={({ item }) => (
          <OptionsItem
            item={item}
            onPress={() => handleOptionPress(item.id)}
            isSelected={item.id === selectedOption}
          />
        )}
        horizontal
      />
    </View>
  )
}
